import {RichTextColorPickerComponentOptions} from "./rich-text-color-picker/rich-text-color-picker.component.js";
import {TimedActionComponentOptions} from "./h-timed-action/timed-action.component.js";

(function() {

    "use strict";

    const module = angular.module("components", []);

    module.component('richTextColorPicker', RichTextColorPickerComponentOptions);
    module.component('timedAction', TimedActionComponentOptions);
})();